import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "data-bs-target"]
const _hoisted_2 = ["id", "aria-labelledby"]
const _hoisted_3 = { class: "modal-dialog modal-dialog-centered modal-dialog-custom" }
const _hoisted_4 = { class: "modal-content d-flex flex-column modal-container" }
const _hoisted_5 = { class: "d-flex header justify-content-between" }
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "footer d-flex justify-content-center" }
const _hoisted_8 = {
  type: "button",
  class: "btn add-to-cart-button align-self-end",
  "data-bs-dismiss": "modal"
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertModalComponent',
  props: {
    header: {
        type: String,
        required: true
    },
    buttonText: {
        type: String,
        required: true
    }
},
  setup(__props, { expose: __expose }) {

const props = __props;

// Generate a unique suffix for IDs to ensure instance isolation
const uniqueSuffix = Math.random().toString(36).substring(2, 9);

const triggerButtonId = computed(() => `alert_modal_button_${uniqueSuffix}`);
const modalContainerId = computed(() => `alert_modal_container_${uniqueSuffix}`);
const modalLabelId = computed(() => `alert_modal_label_${uniqueSuffix}`);

__expose({
    show
});

function show() {
    const modalButton = document.getElementById(triggerButtonId.value);
    modalButton?.click();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("button", {
      id: triggerButtonId.value,
      type: "button",
      class: "btn btn-primary",
      "data-bs-toggle": "modal",
      "data-bs-target": `#${modalContainerId.value}`
    }, null, 8, _hoisted_1), [
      [_vShow, false]
    ]),
    _createElementVNode("div", {
      class: "modal fade",
      id: modalContainerId.value,
      tabindex: "-1",
      "aria-labelledby": modalLabelId.value,
      "aria-hidden": "true"
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h1", {
              class: "modal-title fs-5",
              id: modalLabelId.value
            }, _toDisplayString(props.header), 9, _hoisted_6),
            _cache[0] || (_cache[0] = _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              "aria-label": "Close"
            }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", _hoisted_8, _toDisplayString(props.buttonText), 1)
          ])
        ])
      ])
    ], 8, _hoisted_2)
  ], 64))
}
}

})